<template>
    <div>
        <h6 v-if="(profileId == 0)" class="heading-small text-muted mb-4">Add New Product Option {{ (inputName) ? (" - " + this.inputName) : "" }}</h6>
        <h6 v-else-if="profileId != 0 && this.$attrs.viewMode == true" class="heading-small text-muted mb-4">View Color - {{this.inputName}}</h6>
        <h6 v-else class="heading-small text-muted mb-4">Edit Product Option - {{this.inputName}}</h6>

        <base-alert v-if="errors.length" type="danger">
            <b>You have the following error(s):</b>
            <li v-for="error in errors" :key="error">{{ error }}</li>
        </base-alert>

        <form id="form-proper">
            <div v-if="customFormMode == 1">
                 <!-- Normal -->
                 <a-input-group compact>
                    <a-select v-model="searchFilter" style="width: 25%" size="large">
                        <a-select-option @click="changeSearchFilter('Name')" value="name">Name</a-select-option>
                        <a-select-option @click="changeSearchFilter('Barcode')" value="barcode">Barcode</a-select-option>
                        <a-select-option @click="changeSearchFilter('Stock Number')" value="stock_no">Stock No.</a-select-option>
                        <a-select-option @click="changeSearchFilter('Reference Code')" value="reference_code">Ref. Code</a-select-option>
                    </a-select>
                    <autocomplete 
                        style="width: 75%;" ref="autocomplete" 
                        :placeholder="placeholder" 
                        :source="productEndpoint" 
                        input-class="form-control autocomplete-customs" 
                        results-property="data" 
                        :results-display="formattedDisplay" 
                        :request-headers="authHeaders" 
                        @selected="getProduct"
                        @clear="clearProduct">
                    </autocomplete>
                </a-input-group>
                <hr/>
                <base-input alternative="" label="Code" placeholder="" v-model="prdopt.code" input-classes="form-control" readonly/>
                <base-input alternative="" label="Name" placeholder="" v-model="prdopt.name" input-classes="form-control" readonly required/>
                <base-input label="Product Option Group" required>
                        <a-select
                            v-model="prdopt.product_option_group_id"
                            showSearch
                            placeholder="Select Product Option Group"
                            optionFilterProp="children"
                            style="width: 100%"
                            :filterOption="true"
                        >
                        <a-select-option
                            v-for="option in prodoptgrp"
                            :key="option.id"
                            :value="option.id"
                        >{{ option.code }} - {{ option.name }}</a-select-option
                        >
                    </a-select>
                </base-input>
                <base-input label="Sequence No" required>
                    <a-input type="number" v-model="prdopt.sequence_no"/>
                </base-input>
            </div>
            <div v-if="customFormMode == 2">
                <!-- Override -->
                <dynamic-form :convertedJson="{mode: customForm.mode, groups: customForm.groups}" :formSettings="color" @valueUpdated="updateSettings" :key="dynamicFormKey"/>
            </div>
            <div v-if="customFormMode == 3">
                <!-- Append -->
                <a-tabs defaultActiveKey="1">
                    <a-tab-pane tab="Basic" key="1">
                        <base-input alternative="" label="Code" placeholder="" v-model="prdopt.code" input-classes="form-control"/>
                        <base-input alternative="" label="Name" placeholder="" v-model="prdopt.name" input-classes="form-control" required />
                        <base-input label="Product Option Group">
                            <a-select
                                v-model="prdopt.product_option_group_id"
                                showSearch
                                placeholder="Select Product Option Group"
                                optionFilterProp="children"
                                style="width: 100%"
                                :filterOption="true"
                              >
                                <a-select-option
                                  v-for="option in prodoptgrp"
                                  :key="option.id"
                                  :value="option.id"
                                  >{{ option.code }} - {{ option.name }}</a-select-option
                                >
                              </a-select>
                        </base-input>
                        <base-input label="Sequence No" required>
                            <a-input type="number" v-model="prdopt.sequence_no"/>
                        </base-input>
                    </a-tab-pane>
                    <a-tab-pane tab="Custom Fields" key="2" forceRender>
                        <dynamic-form :convertedJson="{mode: customForm.mode, groups: customForm.groups_append}" :formSettings="color" @valueUpdated="updateSettings" :key="dynamicFormKey" :showErrors="false"/>
                    </a-tab-pane>
                </a-tabs>
            </div>


            <div v-if="this.$attrs.viewMode != true">
                <div  v-if="serverType == 'ho'" style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                    <button v-if="(profileId == 0)" type="button" class="btn btn-primary float-right" @click.prevent="create">Create</button> 
                    <button v-else type="button" class="btn btn-primary float-right" @click.prevent="update">Update</button> 
                </div>
                <div v-else style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                    <button type="button" class="btn btn-primary float-right" @click.prevent="$emit('closeDrawer', null)">Close</button> 
                </div>
            </div>
        </form>
    </div>
</template>


<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage.js'
    import ValidateField from '../../components/validateFormUtils.js'
    import DynamicForm from '../DynamicForm.vue'
    import Autocomplete from "vuejs-auto-complete"
    import { mapState } from 'vuex'
    var component_x;
    export default {
        components: {
            DynamicForm,
            Autocomplete
        },
        computed: {
            ...mapState(['endPoint', 'profileId', 'serverType']),
        },
        mounted: async function () {
            const OptionGroups = await HTTPRequest.getRequest(this.endPoint + 'product_option_groups?sort=name&page=1&per_page=500'  , null)
            this.prodoptgrp = OptionGroups.data
            const sytemModule = await HTTPRequest.getRequest(this.endPoint + 'system_modules/Product Options?field_name=name'  , null)
            const sytemModuleId = sytemModule.id
            const accSystemModuleRequest = await HTTPRequest.getRequest(this.endPoint + 'account_system_modules/' + sytemModuleId +'?field_name=system_module_id'  , null)
            if(this.isJsonString(accSystemModuleRequest.meta) == true){ 
             const accSystemModule = JSON.parse(accSystemModuleRequest.meta)
             if(accSystemModule != null){
                 if(accSystemModule.form_mode != undefined){
                     this.customFormMode = accSystemModule.form_mode
                 }
                 if(accSystemModule.customized_forms != undefined){
                     this.customForm = accSystemModule.customized_forms
                 }
             }
            }

            if(this.serverType == 'branch' || this.$attrs.viewMode == true){
                var form = document.getElementById("form-proper")
                var elements = form.elements;
                for (var i = 0, len = elements.length; i < len; ++i) {
                    elements[i].readOnly = true;
                }
            }
            component_x = this
            if (component_x.profileId > 0){
                var option_data = await HTTPRequest.getRequest(component_x.endPoint + 'product_options/' + component_x.profileId, null)
                if(option_data == undefined){
                    component_x.$router.go()
                } else {
                    if(option_data["error"] == undefined){
                        component_x.prdopt = option_data
                        component_x.inputName = option_data["name"]
                        component_x.inputCode = option_data["code"]
                        component_x.inputRemark = option_data["product_option_group_id"]
                    } else {
                        this.errors = color_data["error"].split(",");
                    } 
                }
            } 

            this.dynamicFormKey++;
        },
        data: function () {
            return {
                inputName: '',
                inputCode: '',
                inputRemark: '',
                errors: [],
                prodoptgrp: [],
                searchFilter: "name",
                placeholder: "Search product by Name",
                authHeaders: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web" },
                customFormMode: 1,
                customForm: {},
                profileData: {},
                dynamicFormKey: 0,
                prdopt: {
                    code: null,
                    name: null,
                    product_option_group_id: null,
                    sequence_no: null
                },
                formErrors: []
            }
        },
        methods: {
            updateSettings(newFormSettings, settingsGrouping, errors){
                var formSettingsCopy = this.bagger
                var mergedHash = Object.assign({}, formSettingsCopy, newFormSettings);
                this.formErrors = errors
                if(this.customFormMode == 3) {
                    this.errors = errors
                }
                this.bagger = mergedHash
            },
            isJsonString(str) {
                try {
                    var json = JSON.parse(str);
                    return (typeof json === 'object');
                } catch (e) {
                    return false;
                }
            },
            changeSearchFilter(searchFilter){
                this.searchFilter = searchFilter
                this.placeholder = "Search product by " + searchFilter
            },
            productEndpoint (input) {
            return this.endPoint + '/products?'+this.searchFilter+'=' + input;
            },
            formattedDisplay (result) {
             return result.name;
            },
            getProduct (group) {
                this.prdopt.code = group.selectedObject.barcode;
                this.prdopt.name = group.selectedObject.name
            },
            clearProduct (){
                this.prdopt.code = null
                this.prdopt.name = null
            },
            validateForm(){
                this.errors = [];
               
                this.errors.push(ValidateField.charMinAndMax('Code', this.prdopt.code, 0, 30));
                this.errors.push(ValidateField.required('Name', this.prdopt.name));
                this.errors.push(ValidateField.charMinAndMax('Name', this.prdopt.name, 0, 50));
                this.errors.push(ValidateField.required('Product Option Group', this.prdopt.product_option_group_id));
                this.errors.push(ValidateField.required('Sequence Number', this.prdopt.sequence_no));
                this.errors = this._.compact(this.errors);
                document.getElementsByClassName('ant-drawer-wrapper-body')[0].scrollTop = 0;
                return this.errors.length;
            },
            create: async function () {
                if(!this.validateForm()) {
                    this.prdopt.name = this.prdopt.name.trim()
                    if (this.prdopt.code != undefined)
                        this.prdopt.code = this.prdopt.code.trim()
                    this.prdopt.status = 'A'
                    var optionPayload = { product_options: this.prdopt }

                    var post_request = await HTTPRequest.postRequest(this.endPoint + 'product_options', null, optionPayload)    
                    if (post_request == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        if (post_request["error"] == undefined) {
                            this.$emit('refreshPage', event)
                        } else {
                            this.errors = post_request["error"].split(",")
                        }
                    }
                }
            },
            update: async function () {
                if(!this.validateForm()) {
                    // var colorPayload = {
                    //     color: {
                    //         name: this.inputName.trim(), 
                    //         code: this.inputCode.trim(), 
                    //         remark: this.inputRemark, 
                    //         status: 'A'
                    //     }
                    // }

                    this.prdopt.name = this.prdopt.name.trim()
                    if (this.prdopt.code != undefined)
                        this.prdopt.code = this.prdopt.code.trim()
                    this.prdopt.status = 'A'
                    var optionPayload = { product_options: this.prdopt }

                    var put_request = await HTTPRequest.putRequest(this.endPoint + 'product_options/' + this.profileId, null, optionPayload)
                    if (put_request == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        if (put_request["error"] == undefined) {
                            this.$emit('refreshPage', event)
                        } else {
                            this.errors = put_request["error"].split(",")
                        }
                    }
                }
            }
        }
    }
</script>

<style>
    .autocomplete-customs {
        height: 38px;
    }
</style>
